import { gql } from "@apollo/client";

export const GET_ALL_ESTADOS_VALIDACION = gql`
query GetAllEstadosValidacion {
    allEstadosValidacion {
        idEstadoValidacion
        clave
    }
}`;